import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { AppointmentSlot } from 'helper/time';

interface ControlledTimeSlotSelectProps {
  name: string;
  control: any;
  error?: any;
  label: string;
  required?: boolean;
  appointmentSlots: AppointmentSlot[];
  helperText?: string;
}

export const ControlledTimeSlotSelect: React.FC<ControlledTimeSlotSelectProps> = ({
  name,
  control,
  error,
  label,
  required = false,
  appointmentSlots,
  helperText,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field: { value, onChange } }) => {
        const hasError = Boolean(error);
        const helperOrErrorText = error?.type === 'required' ? '此欄位為必填欄位' : helperText;

        return (
          <Box display="grid" gap={1}>
            <FormControl fullWidth error={hasError}>
              <InputLabel
                required={required}
                sx={{
                  fontSize: '18px',
                  color: hasError ? '#d32f2f' : '#141921',
                  fontWeight: required ? 600 : 400,
                }}
              >
                {label}
              </InputLabel>
              <Select
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                label={label}
                sx={{
                  '& .MuiSelect-select': {
                    padding: '20px 16px',
                    fontSize: '18px',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
              >
                <MenuItem value="" disabled sx={{ fontStyle: 'italic', color: '#999' }}>
                  請選擇可預約時間
                </MenuItem>
                {appointmentSlots.length > 0 ? (
                  appointmentSlots.map((slot, index) => {
                    const displayValue = slot.studentDisplayTime 
                      ? `${slot.displayDate} - 導師時間: ${slot.mentorDisplayTime} | 您的時間: ${slot.studentDisplayTime}`
                      : `${slot.displayDate} ${slot.displayTime}`;
                    return (
                      <MenuItem key={index} value={displayValue} sx={{ padding: '12px 16px' }}>
                        <Box>
                          <Box sx={{ fontWeight: 600, fontSize: '16px', color: '#141921' }}>
                            {slot.displayDate} ({slot.dayName})
                          </Box>
                          <Box sx={{ fontSize: '14px', color: '#666', marginTop: '2px' }}>
                            🏫 導師時間: {slot.mentorDisplayTime}
                          </Box>
                          {slot.studentDisplayTime && (
                            <Box sx={{ fontSize: '14px', color: '#2196f3', marginTop: '1px', fontWeight: 500 }}>
                              🕒 您的時間: {slot.studentDisplayTime}
                            </Box>
                          )}
                        </Box>
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem value="" disabled sx={{ fontStyle: 'italic', color: '#999' }}>
                    暫無可預約時間
                  </MenuItem>
                )}
              </Select>
              {helperOrErrorText && (
                <FormHelperText
                  error={hasError}
                  sx={{
                    textAlign: 'left',
                    fontSize: '16px',
                    margin: '4px 0px 0px 0px',
                  }}
                >
                  {helperOrErrorText}
                </FormHelperText>
              )}
            </FormControl>
          </Box>
        );
      }}
    />
  );
};